import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import formatUSPhone from "../../utils/phoneUtil";
import getPersonName from "../common/Name";

class RelativesNimbusReport extends Component {
  constructor(props) {
    super(props);
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      rows: [],
      activeIndex: 0,
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rows = [];
    if (props.reportData !== undefined) {
      const relationships = _.get(
        props.reportData,
        "personReport.response[0].output[0].extendedReports[0].extendedReport[0].relatives[0].relative"
      );
      if (relationships !== undefined && relationships.length > 0) {
        if (relationships && relationships.length > 0) {
          _.forEach(relationships, (relationship, index) => {
            const nameNode = _.get(relationship, "names[0].name");
            rows.push(
              <Table.Row key={`rep_rel_row_${index}`}>
                <Table.Cell>
                  <span className="text-bold">Name:</span>
                </Table.Cell>
                <Table.Cell>
                  {nameNode &&
                    nameNode.length > 0 &&
                    getPersonName(
                      _.get(nameNode[0], "firstName[0]._", ""),
                      _.get(nameNode[0], "middleName[0]._", ""),
                      _.get(nameNode[0], "lastName[0]._", ""),
                      props
                    )}
                </Table.Cell>
                <Table.Cell>
                  <span className="text-bold">Age:</span>
                </Table.Cell>
                <Table.Cell>
                  {_.get(relationship, "DOBs[0].DOB[0].age[0]._")}
                </Table.Cell>
                <Table.Cell>
                  <span className="text-bold">Phone:</span>
                </Table.Cell>
                <Table.Cell>{formatUSPhone(_.get(relationship, "addresses[0].address[0].phonesAtAddress[0].phone[0].phoneNumber[0]._"))}</Table.Cell>
              </Table.Row>
            );
          });
        }
      }
      if (rows.length === 0) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }

      this.setState({ rows });
    }
  };

  render() {
    const {rows} = this.state;
    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          key={`RelativesTitle`}
          onClick={() => this.handleClick()}
        >
          <p>Available Relatives</p>
        </Accordion.Title>
        <Accordion.Content
          key={`RelativesBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}
export default RelativesNimbusReport;



// WEBPACK FOOTER //
// ./src/components/reports/RelativesNimbusReport.js